// /app/frontend/src/pages/risk/dpia/steps/ConsultationStep.jsx
import React from 'react';
import { Label } from '../../../../components/ui/label';
import { Textarea } from '../../../../components/ui/textarea';

export default function ConsultationStep({ formData, updateField }) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label>Stakeholders Consulted</Label>
        <Textarea 
          value={formData.stakeholders_consulted}
          onChange={(e) => updateField('stakeholders_consulted', e.target.value)}
          placeholder="List stakeholders consulted (e.g., data subjects, unions, works councils, IT, legal)..."
          rows={4}
        />
      </div>

      <div className="space-y-2">
        <Label>If consultation was not possible, explain why</Label>
        <Textarea 
          value={formData.consultation_justification}
          onChange={(e) => updateField('consultation_justification', e.target.value)}
          placeholder="Justification for not consulting..."
          rows={3}
        />
      </div>
    </div>
  );
}
